module.exports = __webpack_public_path__ + "static/media/component-categories-card.78cf441c.png";